import { addEventEntry, addDataLayerEntry } from '@printdeal/data-layer-manager';

export enum OrderDetailCategories {
  ORDER_DETAIL = 'order_detail',
}

enum OrderDetailEvents {
  ORDER_DETAIL_INTERACTION = 'order_detail_interaction',
}

export const dispatchDataLayerClickTrackAndTrace = () => {
  // GA4
  addDataLayerEntry(OrderDetailEvents.ORDER_DETAIL_INTERACTION, {
    action: 'track_and_trace',
  });

  // GA3
  addEventEntry({
    eventCategory: OrderDetailCategories.ORDER_DETAIL,
    eventAction: 'track_and_trace',
  });
};
